/* Ondeloria — fiche produit.
   1. Choisir une variante fait remonter sa photo sur fond neutre (alt qui
      contient la valeur de l'option + "photograph"), sinon sa mise en scene.
   2. Voir plus / voir moins, avec apparition douce.
   3. Sur telephone : galerie en carrousel, compteur et points.
   4. Bandeau d'achat fixe quand le bouton principal sort de l'ecran. */
(function () {
  function init() {
    var pdp = document.querySelector('[data-onde-pdp]');
    if (!pdp || pdp.__ondeGal) return;
    pdp.__ondeGal = true;

    var media = pdp.querySelector('.onde-pdp__media');
    var sel = pdp.querySelector('[data-onde-ids]');
    if (!media) return;

    var mobile = window.matchMedia('(max-width: 989px)');
    var more = pdp.querySelector('[data-onde-showall]');
    var moreT = more && more.querySelector('[data-onde-more-t]');
    var moreLabel = moreT ? moreT.textContent : '';
    var expanded = false;
    var visible = media.querySelectorAll('.onde-shot:not(.is-hidden)').length || 5;

    function figs() { return Array.prototype.slice.call(media.querySelectorAll('.onde-shot')); }
    function altOf(f) {
      var img = f.querySelector('img');
      return ((img && img.getAttribute('alt')) || '').toLowerCase();
    }

    function rehide() {
      figs().forEach(function (f, i) {
        var hide = !expanded && i >= visible;
        if (!hide && f.classList.contains('is-hidden')) {
          f.classList.add('is-arriving');
          setTimeout(function () { f.classList.remove('is-arriving'); }, 700);
        }
        f.classList.toggle('is-hidden', hide);
      });
      if (more) {
        if (moreT) moreT.textContent = expanded ? (more.getAttribute('data-less') || 'Show fewer photos') : moreLabel;
        var cnt = more.querySelector('span + span');
        if (cnt) cnt.style.display = expanded ? 'none' : '';
        media.appendChild(more);
      }
    }

    if (more) {
      more.addEventListener('click', function () {
        expanded = !expanded;
        rehide();
        if (!expanded) {
          var r = media.getBoundingClientRect();
          if (r.top < 0) window.scrollTo({ top: window.scrollY + r.top - 90, behavior: 'smooth' });
        }
      });
    }

    /* Une valeur d'option peut s'ecrire de plusieurs facons dans le texte
       alternatif : "B" -> "model b", "7" -> "7 lights" / "7 arms". */
    function forms(v) {
      v = (v || '').trim().toLowerCase();
      if (!v) return [];
      if (/^[a-z]$/.test(v)) return ['model ' + v];
      if (/^\d+$/.test(v)) return ['model ' + v, v + ' lights', v + ' light', v + ' arms', v + ' arm'];
      return v.length < 3 ? [] : [v];
    }
    function esc(s) { return s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); }
    function has(alt, f) { return new RegExp('(^|[^a-z0-9])' + esc(f) + '([^a-z0-9]|$)').test(alt); }

    /* La photo qui reprend le plus de valeurs de la variante gagne ; a
       egalite, la premiere dans la galerie. */
    function find(values, studio) {
      var list = figs(), best = null, bestScore = 0;
      list.forEach(function (fig) {
        var a = altOf(fig);
        if (studio !== (a.indexOf('photograph') !== -1)) return;
        var score = 0;
        values.forEach(function (val) {
          if (forms(val).some(function (f) { return has(a, f); })) score++;
        });
        if (score > bestScore) { best = fig; bestScore = score; }
      });
      return best;
    }

    /* Carrousel telephone : compteur et points. */
    var countEl = pdp.querySelector('[data-onde-count]');
    var dots = Array.prototype.slice.call(pdp.querySelectorAll('.onde-pdp__dots i'));
    function onScroll() {
      if (!mobile.matches) return;
      var w = media.clientWidth || 1;
      var idx = Math.round(media.scrollLeft / w);
      if (countEl) countEl.textContent = idx + 1;
      dots.forEach(function (d, k) { d.classList.toggle('is-on', k === Math.min(idx, dots.length - 1)); });
    }
    media.addEventListener('scroll', function () { window.requestAnimationFrame(onScroll); }, { passive: true });

    function toFront(target) {
      if (!target) return;
      if (target !== media.firstElementChild) {
        media.insertBefore(target, media.firstElementChild);
        target.classList.add('is-arriving');
        setTimeout(function () { target.classList.remove('is-arriving'); }, 700);
      }
      rehide();
      if (mobile.matches) {
        media.scrollTo({ left: 0, behavior: 'smooth' });
      } else {
        var r = media.getBoundingClientRect();
        if (r.top < -40) window.scrollTo({ top: window.scrollY + r.top - 90, behavior: 'smooth' });
      }
    }

    /* Bandeau d'achat. */
    var bar = pdp.querySelector('[data-onde-sbar]');
    var add = pdp.querySelector('[data-onde-add]');
    var qtyIn = pdp.querySelector('[data-onde-qtyin]');
    var barQty = pdp.querySelector('[data-onde-sbar-qty]');
    var barAdd = pdp.querySelector('[data-onde-sbar-add]');
    var barImg = pdp.querySelector('[data-onde-sbar-img]');
    var barVar = pdp.querySelector('[data-onde-sbar-var]');
    var barPrice = pdp.querySelector('[data-onde-sbar-price]');

    function clamp(n) { n = parseInt(n, 10) || 1; return Math.min(9, Math.max(1, n)); }
    function syncQty(from) {
      if (!qtyIn || !barQty) return;
      if (from === 'bar') qtyIn.value = clamp(barQty.value);
      barQty.value = clamp(qtyIn.value);
    }

    if (bar) {
      document.body.appendChild(bar);
      pdp.querySelectorAll('[data-onde-qty]').forEach(function (b) {
        b.addEventListener('click', function () { setTimeout(syncQty, 0); });
      });
      if (qtyIn) qtyIn.addEventListener('input', function () { syncQty(); });
      bar.querySelectorAll('[data-onde-sbar-step]').forEach(function (b) {
        b.addEventListener('click', function () {
          barQty.value = clamp((parseInt(barQty.value, 10) || 1) + parseInt(b.getAttribute('data-onde-sbar-step'), 10));
          syncQty('bar');
        });
      });
      if (barQty) barQty.addEventListener('change', function () { syncQty('bar'); });

      var footer = document.querySelector('footer, [data-ref="footer"], .onde-footer');
      var addOut = false;
      var footIn = false;
      function paintBar() {
        var on = addOut && !footIn;
        bar.classList.toggle('is-on', on);
        bar.setAttribute('aria-hidden', on ? 'false' : 'true');
        bar.querySelectorAll('button, input').forEach(function (el) { el.tabIndex = on ? 0 : -1; });
        document.documentElement.classList.toggle('onde-sbar-on', on);
      }
      function check() {
        if (!add) return;
        var ar = add.getBoundingClientRect();
        /* Telephone et tablette : le bandeau reste la tant que le bouton
           principal n'est pas a l'ecran, au-dessus comme en dessous. */
        addOut = ar.bottom < 0 || (mobile.matches && ar.top > window.innerHeight);
        footIn = footer ? footer.getBoundingClientRect().top < window.innerHeight : false;
        paintBar();
      }
      window.addEventListener('scroll', check, { passive: true });
      window.addEventListener('resize', check);
      pdp.__ondeBar = check;
      check();
    }

    function current() {
      if (!sel) return null;
      return sel.options[sel.selectedIndex] || null;
    }

    function paintVariant(opt) {
      if (!opt) return;
      if (barPrice) barPrice.textContent = opt.getAttribute('data-price') || barPrice.textContent;
      if (barVar) barVar.textContent = (opt.textContent || '').trim();
      var ok = opt.getAttribute('data-available') === 'true';
      if (barAdd && add) { barAdd.disabled = !ok; barAdd.textContent = add.textContent.trim(); }
      try {
        var u = new URL(window.location.href);
        u.searchParams.set('variant', opt.value);
        window.history.replaceState(null, '', u.toString());
      } catch (e) {}
    }

    function apply() {
      var opt = current();
      if (!opt) return;
      var values = (opt.getAttribute('data-opts') || '').split('||');
      var target = find(values, true) || find(values, false);
      toFront(target);
      if (barImg && target) {
        var im = target.querySelector('img');
        if (im) barImg.src = im.currentSrc || im.src;
      }
      paintVariant(opt);
    }

    if (sel) sel.addEventListener('change', apply);
    pdp.addEventListener('click', function (e) {
      var t = e.target;
      if (t && t.closest && t.closest('[data-onde-val]')) setTimeout(apply, 0);
    });

    /* Arrivee avec ?variant= (lien du questionnaire) : la mise en scene de
       cette couleur passe en premier. */
    try {
      if (new URL(window.location.href).searchParams.get('variant') && current()) {
        var vals = (current().getAttribute('data-opts') || '').split('||');
        var first = find(vals, false);
        if (first && first !== media.firstElementChild) { media.insertBefore(first, media.firstElementChild); rehide(); }
        paintVariant(current());
      }
    } catch (e) {}

    syncQty();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
